module.exports = __webpack_public_path__ + "1b85e101506f58059199e4fe8899e28b.pdf";